import { Dispatch } from 'redux';
import {
  createFavoriteProductList,
  deleteFavoriteProductList,
  updateFavoriteProductList as updateFavoriteProductListQuery,
} from '../../../graphql/mutations';
import { FavoriteProductList } from '../actions';
import {
  recievedFavoriteProductList,
  removedFavoriteProductList,
  updatedFavoriteProductList,
} from '~redux/favorite/reducers/product';
import { removeFavoriteProduct } from '~redux/favoriteproduct/thunk';
import { executeQuery } from '~utils/graphql';

export const removeFavoriteProductList = (
  id: string,
  favoriteProductIds: string[]
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    await Promise.all(
      favoriteProductIds.map(async (id) => {
        await removeFavoriteProduct(id)(dispatch);
      })
    );
    await executeQuery(deleteFavoriteProductList, {
      input: { id },
    });
    dispatch(removedFavoriteProductList(id));
  };
};

export const updateFavoriteProductList = (
  account_id: string,
  list_id: string,
  list_name: string
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    const rs = await executeQuery(updateFavoriteProductListQuery, {
      input: {
        id: list_id,
        account_id: account_id,
        list_name: list_name,
      },
    });
    dispatch(
      updatedFavoriteProductList({
        listId: list_id,
        list: rs.data.updateFavoriteProductList,
      })
    );
  };
};

export const addFavoriteProductList = (
  account_id: string,
  listName: string,
  listId?: string
) => {
  return async (dispatch: Dispatch): Promise<void> => {
    let id = listId;
    if (!id) {
      const charList =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      const len = 16;
      id = Array.from(Array(len))
        .map(() => charList[Math.floor(Math.random() * charList.length)])
        .join('');
    }
    const favoriteProductListData: FavoriteProductList = {
      id: id,
      account_id: account_id,
      list_name: listName,
      order: 0,
    };

    const res = await executeQuery(createFavoriteProductList, {
      input: favoriteProductListData,
    });
    const {
      data: { createFavoriteProductList: item },
    } = res;

    dispatch(recievedFavoriteProductList([item]));
  };
};
